(() => {
  const MSG_ARCHIVE_BLOCKED_BY_CART =
    "Votre panier contient déjà des articles d'une autre collection. Les produits Archive ne peuvent être achetés qu'entre eux.";
  const MSG_REGULAR_BLOCKED_BY_ARCHIVE =
    "Votre panier contient un produit de la collection Archive. Vous ne pouvez pas y ajouter d'autres produits.";

  const state = { hasArchive: false, hasRegular: false, ready: false };

  const updateState = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    let hasArchive = false;
    let hasRegular = false;
    for (const item of cart.items) {
      const archived = !!(item.properties && item.properties._archive_only);
      const gift =
        item.original_price === 0 ||
        !!(item.properties && (item.properties._promo || item.properties._auto_y2k_gift));
      if (gift) continue;
      if (archived) hasArchive = true;
      else hasRegular = true;
    }
    state.hasArchive = hasArchive;
    state.hasRegular = hasRegular;
    state.ready = true;
  };

  const fetchCart = () =>
    fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then((r) => r.json())
      .then(updateState)
      .catch(() => {});

  fetchCart();

  document.documentElement.addEventListener("cart:change", (e) => {
    if (e.detail?.cart) updateState(e.detail.cart);
    else fetchCart();
  });

  const showError = (form, message) => {
    form.dispatchEvent(
      new CustomEvent("cart:error", {
        bubbles: true,
        detail: { error: message },
      }),
    );
    const submitButtons = Array.from(form.elements).filter(
      (el) => el.type === "submit",
    );
    submitButtons.forEach((btn) => btn.removeAttribute("aria-busy"));
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true }),
    );
  };

  const removeNonArchiveItems = async (trigger) => {
    trigger.setAttribute("aria-busy", "true");
    trigger.disabled = true;
    try {
      const cart = await fetch(
        `${window.Shopify?.routes?.root || "/"}cart.js`,
        { headers: { "X-Requested-With": "XMLHttpRequest" } },
      ).then((r) => r.json());
      const updates = {};
      let any = false;
      for (const item of cart.items) {
        const isArchive = !!(item.properties && item.properties._archive_only);
        const isGift =
          item.original_price === 0 ||
          (item.properties && (item.properties._promo || item.properties._auto_y2k_gift));
        if (!isArchive && !isGift) {
          updates[item.key] = 0;
          any = true;
        }
      }
      if (!any) {
        trigger.removeAttribute("aria-busy");
        trigger.disabled = false;
        return;
      }
      await fetch(`${window.Shopify?.routes?.root || "/"}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ updates }),
      });
      window.location.reload();
    } catch (err) {
      trigger.removeAttribute("aria-busy");
      trigger.disabled = false;
    }
  };

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-archive-remove-non-archive]");
    if (!trigger) return;
    e.preventDefault();
    removeNonArchiveItems(trigger);
  });

  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]'))
        return;
      if (!state.ready) return;

      const productForm = form.closest("product-form");
      const isArchiveSubmit = !!productForm?.hasAttribute("data-archive-only");

      let blocked = false;
      let message = "";
      if (isArchiveSubmit && state.hasRegular) {
        blocked = true;
        message = MSG_ARCHIVE_BLOCKED_BY_CART;
      } else if (!isArchiveSubmit && state.hasArchive) {
        blocked = true;
        message = MSG_REGULAR_BLOCKED_BY_ARCHIVE;
      }

      if (blocked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(form, message);
      }
    },
    { capture: true },
  );
})();
